<template>
  <v-card
    class="mx-auto"
    max-width="344"
    outlined
  >
    <v-list-item three-line>
      <v-list-item-content>
        <!--<div class="text-overline mb-4">
          OVERLINE
        </div>-->
        <v-list-item-title class="text-h7 mb-1">
          {{title}}
        </v-list-item-title>
        <v-list-item-subtitle>{{subtitle}}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-img
      height="150"
      :src="imgSrc"
    ></v-img>
    <v-card-actions>
      <v-btn
        outlined
        rounded
        text
        @click="goToLink()"
      >
        Read Article
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
  export default {
    props:{
        title:String,
        subtitle:String,
        imgSrc:String,
        linkUrl:String
    },
    mounted(){
        console.log("MediumCard Mounted Title:"+this.title," -Subtitle:"+this.subtitle);
    },
    methods:{
        goToLink(){
            console.log("Url is:"+this.linkUrl);
            window.open(this.linkUrl, "_blank")
        }
    }

  }
</script>
<style scoped>

</style>